import React, { Fragment } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'
import { Paragraph, Placeholder, H4 } from '../../GlobalStyles'
import styled from 'styled-components'
import { ButtonLink } from '../../common/Links'
import theme from '../../theme'
import Img from 'gatsby-image'
import { prop } from 'ramda'

export const SetWrapper = styled.div`
  text-align: center;
  width: 100%;
`

export const CardWrapper = styled.div`
  position: relative;
  .gatsby-image-wrapper {
    @media screen and (max-width: 1200px) {
      width: 50%;
      float: left;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
`

export const CardInner = styled.div`
  padding-bottom: 87%;
  @media screen and (max-width: 1200px) {
    width: 50%;
    float: left;
    padding-bottom: 0;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  > img {
    max-width: 100%;
  }
`

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
  color: ${p => p.color || p.theme.colors.gold};
  margin-bottom: 15px;
  @media screen and (min-width: 1025px) {
    font-size: 38px;
    margin-bottom: 23px;
  }
`

export const CardCol = styled(Col)`
  &:nth-child(2) {
    background-color: #eff0f0;
  }
`
export const CardText = styled.div`
  padding: 60px 35px;
  position: absolute;
  @media screen and (max-width: 1200px) {
    position: relative;
    padding: 90px 35px 30px;
  }
  @media screen and (max-width: 768px) {
    padding: 30px 35px 30px;
  }
`

export const ButtonsContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #eff0f0;
  padding: 20px 0;
`

export const CardsSecondary = () => (
  <StaticQuery
    query={graphql`
      query {
        Tiles1: file(relativePath: { eq: "Home/Card1.jpg" }) {
          ...optimizedImage
        }
        Tiles2: file(relativePath: { eq: "Home/Card2.jpg" }) {
          ...optimizedImage
        }
        Tiles3: file(relativePath: { eq: "Home/Card3.jpg" }) {
          ...optimizedImage
        }
        BrandImages: file(relativePath: { eq: "Home/BrandImages.png" }) {
          ...optimizedImage
        }
      }
    `}
    render={data => (
      <Fragment>
        <SetWrapper>
          <Row noGutters>
            <CardCol xs='12' xl='4'>
              <CardWrapper>
                {prop('Tiles1', data) ? (
                  <Img fluid={data.Tiles1.childImageSharp.fluid} />
                ) : (
                  <Placeholder />
                )}
                <CardInner>
                  <CardText>
                    <H4 color={theme.colors.navy}>Why Does ADM Work?</H4>
                    <Paragraph>
                      American Development Model was designed by sports
                      scientists to help support a lifetime affinity to sports,
                      and to develop athletes to their greatest potential. These
                      principles align physical and psychological development to
                      stages, delivering appropriate skills and exercise at the
                      appropriate time.
                    </Paragraph>
                  </CardText>
                </CardInner>
              </CardWrapper>
            </CardCol>
            <CardCol xs='12' xl='4'>
              <CardWrapper>
                <CardInner>
                  <CardText>
                    <H4 color={theme.colors.navy}>How Does ADM Work?</H4>
                    <Paragraph>
                      Creating positive experiences early, for all athletes,
                      will keep more players engaged and retained in our sport.
                      Introducing the right aspects of play in a structure that
                      is fun, engaging, and progressively challenging, allows
                      golfers of all ages to experience the challenges and joys
                      of our sport.
                    </Paragraph>
                  </CardText>
                </CardInner>
                {prop('Tiles2', data) ? (
                  <Img fluid={data.Tiles2.childImageSharp.fluid} />
                ) : (
                  <Placeholder />
                )}
              </CardWrapper>
            </CardCol>
            <CardCol xs='12' xl='4'>
              <CardWrapper>
                {prop('Tiles3', data) ? (
                  <Img fluid={data.Tiles3.childImageSharp.fluid} />
                ) : (
                  <Placeholder />
                )}
                <CardInner>
                  <CardText>
                    <H4 color={theme.colors.navy}>What Is The ADM?</H4>
                    <Paragraph>
                      Golf's new pathway is built on the principles of the
                      American Development Model (ADM), a proven, long-term
                      athlete development model that has been successfully
                      applied to USA Hockey, USOC, USA Basketball and USA
                      Lacrosse.
                    </Paragraph>
                    {prop('BrandImages', data) ? (
                      <Img fluid={data.BrandImages.childImageSharp.fluid} />
                    ) : (
                      ''
                    )}
                  </CardText>
                </CardInner>
              </CardWrapper>
            </CardCol>
          </Row>
          <Row noGutters>
            <ButtonsContainer>
              <ButtonLink
                url='https://pgacoach.lightspeedvt.com/'
                bgColor={theme.colors.transparent}
                borderColor={theme.colors.lightBlue}
                color={theme.colors.lightBlue}
                bgHoverColor={theme.colors.lightBlue}
                borderHoverColor={theme.colors.white}
                padding='8px 15px'
                aria-label='Get Started Here'
              >
                Get Started Here
              </ButtonLink>
            </ButtonsContainer>
          </Row>
        </SetWrapper>
      </Fragment>
    )}
  />
)

Row.propTypes = {
  noGutters: PropTypes.bool,
  form: PropTypes.bool
}

export default CardsSecondary
